import * as Factory from 'factory.ts'
import faker from 'faker'

import { AccountCodeMock } from './accountcode.factory'
import { DepartmentMock } from './department.factory'
import { type Account } from '../../models'

export const AccountMock = Factory.Sync.makeFactory<Account>({
  id: Factory.each(() => faker.random.number()),
  account_code: Factory.each(() => AccountCodeMock.build()),
  active: true,
  department: Factory.each(() => DepartmentMock.build()),
  end_datetime: Factory.each(() => faker.date.future().toISOString()),
  start_datetime: Factory.each(() => faker.date.past(10).toISOString()),
  warning_indicator: false,
})
